import DrawHero from '../../features/draws/layouts/hero';
import DrawHistory from '../../features/draws/layouts/history';
import HowItWorks from '../../features/landing/how-it-works';

export default function HomePage() {
    return (
        <>
            <DrawHero />
            <HowItWorks />
            <DrawHistory />
        </>
    );
}
